<template>
  <div v-if="editModeActive"
    :class="['editable-text', 'input-group', inline ? 'input-group-inline' : '']">
    <input
      size="small"
      type="text"
      :class="inline ? ['editable-text-form-inline'] : [] /* ['form-control', 'form-control-sm'] */"
      :value="text"
      :placeholder="placeholder"
      ref="text_input"
      @click.stop
      @dblclick.stop
      @focus="focus"
      @blur="unfocus"
      @keyup="hasUnsavedChanges=true;"
      @keydown.enter="updateText" />
    <span class="input-group-append">
      <button class="btn btn-success btn-sm" type="button" @click="updateText">Save</button>
      <button class="btn btn-primary btn-sm" type="button" @click="enterEditMode({status: false})">Cancel</button>
    </span>
  </div>
  <div v-else
    @click="enterEditMode({status: true})"
    :style="{ display: inline ? 'inline' : 'block' }">
    <slot v-bind:text="text">
      <p>{{ text }}</p>
    </slot>
    <font-awesome-icon v-if="showEditIcon" icon="edit" @click="enterEditMode({status: !editModeActive})" style="cursor: pointer" />
  </div>
</template>

<script>
// import { mapMutations } from "vuex";

// TODO: Esc to Exit
// TODO: Enter to confirm

export default {
  props: {
    inline: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "add title here"
    },
    id: {
      type: String
    },
    text: {
      type: String,
      default: ""
    },
    showEditIcon: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },

  watch: {
    id() {
      /* Set edit mode to false when goal is changed */
      this.editModeActive = false;
      // setTimeout(() => {
      //   /* HACK */
      //   this.UNSUPPRESS_KEYBOARD_LISTENER();
      // }, 100);
    }
  },

  components: {
  },

  data() {
    return {
      hasUnsavedChanges: false,
      editModeActive: false
    };
  },

  created() {
    this.keyboardShortcutListener = (e) => {
      if ( e.key === 'Escape' || e.code === 'Escape' ) {
        this.editModeActive = false;
      }
    }
    window.addEventListener('keyup', this.keyboardShortcutListener);
  },

  beforeDestroy() {
    // this.UNSUPPRESS_KEYBOARD_LISTENER();
    // this.editModeActive = false;
    if ( this.keyboardShortcutListener ) {
      window.removeEventListener('keyup', this.keyboardShortcutListener)
    }
  },

  methods: {
    // ...mapMutations("project <<", [
    //   "SUPPRESS_KEYBOARD_LISTENER",
    //   "UNSUPPRESS_KEYBOARD_LISTENER"
    // ]),

    focus(evt) {
      // this.SUPPRESS_KEYBOARD_LISTENER();
    },

    // unfocus(evt) {
    //   setTimeout(() => {
    //     this.UNSUPPRESS_KEYBOARD_LISTENER();
    //   }, 100);
    // },

    updateText: function(event) {
      let text = this.$refs.text_input.value;

      this.hasUnsavedChanges = false;
      this.enterEditMode({ status: false });

      this.$emit("update", text);
    },

    enterEditMode: function({ status }) {
      if ( !this.isEditable ) {
        return
      }
      this.editModeActive = status;
      if ( status ) {
        this.$emit('enter-edit-mode')
        this.$nextTick(function () {
          if ( this.$refs.text_input ) {
            this.$refs.text_input.select();
          }
          // this.$refs.text_input.focus();
        })
      } else {
        this.$emit('exit-edit-mode')
      }
    }
  }
};
</script>

<style>
.editable-text {
}
.editable-text-form-inline {
  width: 200px !important;
  /* display: inline-block;
  border: 0; */
}
.editable-text.input-group {
  margin-bottom: 0.9em;
}
.editable-text.input-group-inline {
  margin-bottom: 4px;
  display: inline-block;
  width: 75%;
}
.editable-text.input-group-inline input.form-control {
  display: inline-flex;
  width: calc(100% - 150px); /* ??? */
  margin: 0 0.5em;
}
.editable-text.input-group-inline .input-group-append {
  display: inline-flex;
  margin-left: -5px;
}
.editable-text .input-group-append {
  height: 32px;
}
</style>
